import { UseMutateAsyncFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { editChangeMonitoring } from '@api/manageNetworkElementConfigurations';

import { IChangeMonitoringEditDTO } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { EUserRoles } from '@enums/common';

import {
	NETWORK_ELEMENT_CHANGE_MONITORING,
	NETWORK_ELEMENT_CHANGE_MONITORING_STATUSES,
	NETWORK_ELEMENT_CHANGE_MONITORING_USERS,
	NETWORK_ELEMENT_CHANGES_MONITORING_CARD,
	NETWORK_ELEMENT_EDIT_CHANGE_MONITORING,
} from '@constants/queryKeys';

interface IUseMutateChangeMonitoringEditReturned {
	isLoadingEditChangeMonitoring: boolean;
	editChange: UseMutateAsyncFunction<any, any, IChangeMonitoringEditDTO, any>;
}

const useMutateChangeMonitoringEdit = (
	onSuccess?: () => void,
	onError?: () => void,
): IUseMutateChangeMonitoringEditReturned => {
	const queryClient = useQueryClient();

	const {
		isLoading,
		mutateAsync,
	} = useMutation<IChangeMonitoringEditDTO>({
		mutationKey: [NETWORK_ELEMENT_EDIT_CHANGE_MONITORING],
		mutationFn: editChangeMonitoring,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}

			return queryClient.invalidateQueries([
				NETWORK_ELEMENT_CHANGE_MONITORING,
				NETWORK_ELEMENT_CHANGES_MONITORING_CARD,
				NETWORK_ELEMENT_CHANGE_MONITORING_USERS,
				NETWORK_ELEMENT_CHANGE_MONITORING_STATUSES,
			]);
		},
		onError,
	});

	return {
		isLoadingEditChangeMonitoring: isLoading,
		editChange: mutateAsync,
	};
};

export default useMutateChangeMonitoringEdit;
